export default __webpack_public_path__ + "static/media/Group 6507@3x.106fa30b.png";